import React, { useEffect, useState } from 'react';
import {
  GridComponent, ColumnsDirective, ColumnDirective,
  Resize, Sort, ContextMenu, Filter, Page,
  ExcelExport, PdfExport, Edit, Inject
} from '@syncfusion/ej2-react-grids';
import { userGrid } from '../data/config';
import { users_data } from '../data/sql_data';
import { contextMenuItems } from '../data/dummy';
import { Header } from '../components';

const UserList = () => {
  const [users, setUsers] = useState([]);

  const editing = { allowDeleting: true, allowEditing: true };

  useEffect(() => {
    const fetchUsers = async () => {
      const data = await users_data();
      setUsers(data);
    };
    fetchUsers();
  }, []);

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Page" title="Users" />
      <GridComponent
        id="gridcomp"
        dataSource={users}
        allowPaging
        allowSorting
        allowExcelExport
        allowPdfExport
        contextMenuItems={contextMenuItems}
        editSettings={editing}
      >
        <ColumnsDirective>
          {userGrid.map((item, index) => (
            <ColumnDirective key={index} {...item} />
          ))}
        </ColumnsDirective>
        <Inject
          services={[Resize, Sort, ContextMenu, Filter, Page, ExcelExport, Edit, PdfExport]}
        />
      </GridComponent>
    </div>
  );
};

export default UserList;
